import React from 'react'
import styles from './Responses.module.css'
import { useHistory } from 'react-router-dom'

import List from './List/List'

const Responses = () => {

    const history = useHistory()
    const user = JSON.parse(localStorage.getItem('profile'))

    return (
        <div>
            {
                user.result?.role !== 'admin' ? (<div>{history.push('/')}</div>) :
                (
            <div className={styles.container}>
                <h3 className={styles.title}>Recent activities</h3>
                <List />
            </div>
                )
            }
        </div>

    )
}

export default Responses
